import { Link } from "@tanstack/react-router"
import { Carousel } from "@mylaunch/components/ui"
import { PartnerCarouselCard } from "./partner-carousel-card"
import { usePartners } from "../hooks/use-partners"

export function PartnersCarousel() {
  const { data: partners } = usePartners()

  return (
    <Carousel
      className="gap-0!"
      items={partners}
      getKey={(p) => p.id}
      renderItem={(p) =>
        p.link ? (
          <Link to={p.link} target="_blank" rel="noopener noreferrer">
            <PartnerCarouselCard partner={p} />
          </Link>
        ) : (
          <PartnerCarouselCard partner={p} />
        )
      }
    />
  )
}
